export default __webpack_public_path__ + "static/media/16.e190cf09.png";